import { NextSeo } from 'next-seo';
import Head from 'next/head';

//screens
import { Contact } from '@/screens/Latam/Contact';

//data-helpers
import { JsonLd, Organization } from '@/datafiles/micro-data';
import { getLatamDictionary } from '@/datafiles/languages/latam';
import { buildLatamChrome } from '@/datafiles/nav/latam';
import { OgLocaleAlternates } from '@/components/OgLocaleAlternates';
import { getLocalizedSeo } from '@/datafiles/i18n/seo';

// One body for every LATAM Contact route (/en/contact/, /pt-br/contato/,
// /es-mx/contacto/, /es-co/contacto/): each route file only picks the locale.
export function LatamContactPage({ locale }) {
  const { contact } = getLatamDictionary(locale);
  const { nav, footer } = buildLatamChrome(locale);
  const seo = getLocalizedSeo('latam-contact', locale);

  const hero_content = {
    kicker: contact.hero.kicker,
    title: contact.hero.title,
    description: contact.hero.description,
    ctaLabel: contact.hero.cta_label,
  };

  const office_content = {
    title: contact.office.title,
    name: contact.office.name,
    addressLines: contact.office.address_lines,
    ctaLabel: contact.office.cta_label,
    imageAlt: contact.office.image_alt,
  };

  const needAssistance_content = {
    title: contact.need_assistance.title,
    cards: contact.need_assistance.cards,
  };

  const getInTouch_content = {
    title: contact.get_in_touch.title,
    subtitle: contact.get_in_touch.subtitle,
    smsDisclosureHtml: contact.get_in_touch.sms_disclosure_html,
  };

  const backgroundImageSection_content = {
    title: contact.background_image_section.title,
    description: contact.background_image_section.description,
    image: {
      xxlarge: 'images/careers/become/become-loadie-xxlg.jpg',
      large: 'images/careers/become/become-loadie-lg.jpg',
      medium: 'images/careers/become/become-loadie-md.jpg',
      small: 'images/careers/become/become-loadie-sm.jpg',
    },
    CTA: {
      label: contact.background_image_section.cta_label,
      link: 'https://jobs.lever.co/loadsmart/',
      external: true,
    },
    biggerBg: false,
  };

  return (
    <>
      <Head>
        <meta name="keywords" content={contact.meta_keywords} />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG === 'true'}
        noindex={process.env.NOINDEX_FLAG === 'true'}
        title={contact.meta_title}
        description={contact.meta_description}
        canonical={seo.canonical}
        languageAlternates={seo.languageAlternates}
        openGraph={{ url: seo.canonical, locale: seo.ogLocale }}
      />
      <OgLocaleAlternates locales={seo.ogLocaleAlternates} />
      <JsonLd data={Organization} />
      <Contact
        hero_content={hero_content}
        office_content={office_content}
        needAssistance_content={needAssistance_content}
        getInTouch_content={getInTouch_content}
        backgroundImageSection_content={backgroundImageSection_content}
        nav={nav}
        footer={footer}
      />
    </>
  );
}
